import { render, staticRenderFns } from "./ProductReparationPage.vue?vue&type=template&id=028cb686&"
import script from "./ProductReparationPage.vue?vue&type=script&lang=js&"
export * from "./ProductReparationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports